exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading[data-v-1dfebfa4]{padding:12px;text-align:center}.message.warning[data-v-1dfebfa4]{margin:12px}", ""]);

// exports
